﻿import { contextualCore } from './ContextualCore';

export default class ContextualItem {
    //element;
    /**
     * 
     * @param {Object} opts
     * @param {string} [opts.label]
     * @param {string} [opts.type]
     * @param {string} [opts.markup]
     * @param {string} [opts.icon]
     * @param {string} [opts.cssIcon]
     * @param {string} [opts.shortcut]
     * @param {void} [opts.onClick]
     * @param {boolean} [opts.enabled]
     * @param {Array<ContextualItem>} [opts.items]
     * 
     */
    constructor(opts) {
        this.target = opts.target;
        this.owner = opts.owner;
        switch (opts.type) {
            case 'seperator':
                this.seperator();
                break;
            case 'custom':
                this.custom(opts.markup);
                break;
            case 'multi':
                this.multiButton(opts.items);
                break;
            case 'submenu':
                this.subMenu(opts.label, opts.items, (opts.icon !== undefined ? opts.icon : ''), (opts.cssIcon !== undefined ? opts.cssIcon : ''), (opts.enabled !== undefined ? opts.enabled : true));
                break;
            case 'hovermenu':
                this.hoverMenu(opts.label, opts.items, (opts.icon !== undefined ? opts.icon : ''), (opts.cssIcon !== undefined ? opts.cssIcon : ''), (opts.enabled !== undefined ? opts.enabled : true));
                break;
            case 'normal':
            default:
                this.button(opts.label, opts.onClick, (opts.shortcut !== undefined ? opts.shortcut : ''), (opts.icon !== undefined ? opts.icon : ''), (opts.cssIcon !== undefined ? opts.cssIcon : ''), (opts.enabled !== undefined ? opts.enabled : true));
        }
    }

    button(label, onClick, shortcut = '', icon = '', cssIcon = '', enabled = true) {
        this.element = contextualCore.CreateEl(`
            <li class='contextualJs contextualMenuItemOuter context-menu-item context-menu-icon context-menu-icon--fa5 context-menu-popup'>
                ${icon != '' ? `<img src='${icon}' class='contextualJs contextualMenuItemIcon'/>` : `<i class='${cssIcon != '' ? cssIcon : ''}'></i>`}
                <span class='contextualJs contextualMenuItemTitle'>${label == undefined || label === '' ? ' ' : label}</span>
                <span class='contextualJs contextualMenuItemTip'>${shortcut == '' ? '' : shortcut}</span>
            </li>`);

        if (enabled == true) {
            this.element.addEventListener('click', () => {
                event.stopPropagation();
                if (onClick !== undefined) { onClick(); }
                if (this.target == null) {
                    contextualCore.CloseMenu(this.target, this.owner);
                }
            }, false);
        }
    }
    custom(markup) {
        this.element = contextualCore.CreateEl(`<li class='contextualJs contextualCustomEl'>${markup}</li>`);
    }
    hoverMenu(label, items, icon = '', cssIcon = '', enabled = true) {
        this.element = contextualCore.CreateEl(`
            <li class='contextualJs contextualHoverMenuOuter context-menu-item context-menu-icon context-menu-icon--fa5 context-menu-popup'>
                ${icon != '' ? `<img src='${icon}' class='contextualJs contextualMenuItemIcon'/>` : `<i class='${cssIcon != '' ? cssIcon : ''}'></i>`}
                <span class='contextualJs contextualMenuItemTitle'>${label == undefined ? 'No label' : label}</span>
                <span class='contextualJs contextualMenuItemOverflow'>></span>
                <ul class='contextualJs contextualHoverMenu'>
                </ul>
            </li>
        `);

        let childMenu = this.element.querySelector('.contextualHoverMenu'),
            menuItem = this.element.querySelector('.contextualHoverMenuItem');

        if (items !== undefined) {
            items.forEach(i => {
                i.target = this.target;
                i.owner = this.owner;
                let item = new ContextualItem(i);
                childMenu.appendChild(item.element);
            });
        }
        if (enabled == true) {
            menuItem.addEventListener('mouseenter', () => {

            });
            menuItem.addEventListener('mouseleave', () => {

            });
        }
    }
    multiButton(buttons) {
        this.element = contextualCore.CreateEl(`
            <li class='contextualJs contextualMultiItem context-menu-item context-menu-icon context-menu-icon--fa5 context-menu-popup'>
            </li>
        `);
        buttons.forEach(i => {
            i.target = this.target;
            i.owner = this.owner;
            let item = new ContextualItem(i);
            this.element.appendChild(item.element);
        });
    }
    subMenu(label, items, icon = '', cssIcon = '', enabled = true) {
        this.element = contextualCore.CreateEl(`
            <li class='contextualJs contextualMenuItemOuter contextualSubMenuParent context-menu-item context-menu-icon context-menu-icon--fa5 context-menu-popup'>
                ${icon != '' ? `<img src='${icon}' class='contextualJs contextualMenuItemIcon'/>` : `<i class='${cssIcon != '' ? cssIcon : ''}'></i>`}
                <span class='contextualJs contextualMenuItemTitle'>${label == undefined ? 'No label' : label}</span>
                <span class='contextualJs contextualMenuItemOverflow'>
                    <span class='contextualJs contextualMenuItemOverflowLine'></span>
                    <span class='contextualJs contextualMenuItemOverflowLine'></span>
                    <span class='contextualJs contextualMenuItemOverflowLine'></span>
                </span>
                <ul class='contextualJs contextualMenu contextualSubMenu contextualMenuHidden'>
                </ul>
            </li>`);

        let childMenu = this.element.querySelector('.contextualSubMenu'),
            menuItem = this.element.querySelector('.contextualMenuItemTitle');

        if (items !== undefined) {
            items.forEach(i => {
                i.target = this.target;
                i.owner = this.owner;
                let item = new ContextualItem(i);
                childMenu.appendChild(item.element);
            });
        }
        if (enabled == true) {
            this.element.addEventListener('click', (event) => {
                if (childMenu.contains(event.target)) {
                    return;
                }
                event.stopPropagation();
                menuItem.classList.toggle('SubMenuActive');
                childMenu.classList.toggle('contextualMenuHidden');
            }, false);
        }
    }
    seperator(label, items) {
        this.element = contextualCore.CreateEl(`<li class='contextualJs contextualMenuSeperator context-menu-item context-menu-separator context-menu-not-selectable context-menu-popup'><span></span></li>`);
    }
}
